import React, {useEffect, useState} from "react";
import {gameHistory} from "@constants/Enums";
import {HistoryTotalIcon} from "@resource";
import GameHistoryIcon from "@components/gameHistory/gameHistoryIcon";

function GameHistoryHeader({history}) {
    const [total, setTotal] = useState(0)
    const [winPlayerA, setWinPlayerA] = useState(0)
    const [winPlayerB, setWinPlayerB] = useState(0)
    const [tie, setTie] = useState(0)
    useEffect(() => {
        let winPlayerA = 0,
            winPlayerB = 0,
            tie = 0;
        history.forEach(item => {
            if (item.BetEvent === gameHistory.DragonWin) {
                winPlayerA++
            }

            if (item.BetEvent === gameHistory.TigerWin) {
                winPlayerB++
            }

            if (item.BetEvent === gameHistory.Tie || item.BetEvent === gameHistory.SuitedTie) {
                tie++
            }
        })
        setTotal(history.length);
        setTie(tie);
        setWinPlayerA(winPlayerA);
        setWinPlayerB(winPlayerB);
    }, [history])
    return (
        <div className="game-history-header">
            <ul className="list">
                <li className="list-item">
                   <div className="icon"><HistoryTotalIcon /></div> {total}
                </li>
                <li className="list-item">
                    <GameHistoryIcon won={gameHistory.DragonWin} type="small"/> {winPlayerA}
                </li>
                <li className="list-item">
                    <GameHistoryIcon won={gameHistory.TigerWin} type="small"/> {winPlayerB}
                </li>
                <li className="list-item">
                    <GameHistoryIcon won={gameHistory.Tie} type="small"/> {tie}
                </li>
            </ul>
        </div>
    )
}

export default GameHistoryHeader